import { render, staticRenderFns } from "./listV2.vue?vue&type=template&id=8a44f342"
import script from "./listV2.vue?vue&type=script&lang=js"
export * from "./listV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports